import React from 'react';

const HallUpdate = () => {
    return (
        <div>
            
        </div>
    );
};

export default HallUpdate;